import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
  Stack
} from "@mui/material";
import React, { useEffect } from "react";
import "./ProductCard.css";


const ProductCard = ({ product, handleAddToCart, cartItem, data }) => {
 
  return (
    <Card className="card" variant="outlined">
      {/* <CardActions> */}
        <CardMedia
            component="img"
            height="200"
            image={product.image}
            alt="green iguana"
            variant="outlined"
          />
          <CardContent>
            <Stack spacing={1}>
              <Typography gutterBottom variant="h5" component="div">
                {product.name}
              </Typography>
              <Typography variant="h6" color="text.secondary">
              ${product.cost}
              </Typography>
              <Rating name="read-only" value={product.rating} readOnly />
              <Button className="atc" color="success" onClick={() => handleAddToCart(localStorage.getItem("token"), cartItem, data, product._id, 1, {preventDuplicate: true})}>Add to Cart</Button>
            </Stack>       
          </CardContent>
      {/* </CardActions> */}
    </Card>
  );
};

export default ProductCard;
